import { HELP_URL } from '../../config/externalURL';
import { GOLOCKER_KIOSK_HELP_URL } from '../../utils/goLocker';
import infoIcon from '../../images/info-circle-icon.svg';
import arrowUpRightIcon from '../../images/icon-arrow-up-right.svg';

import styles from './GoLockerNeedHelp.module.scss';

const HelpLink = ({ href, children }) => (
  <a href={href} className={styles.row} target="_blank" rel="noreferrer">
    <img src={infoIcon} alt="" className={styles.rowIcon} />
    <span className={styles.rowLabel}>{children}</span>
    <img src={arrowUpRightIcon} alt="" className={styles.rowArrow} />
  </a>
);

/**
 * GoLockerNeedHelp — the GoLocker "Need Help?" block (G3 12229:3415 / E3 12258:7233):
 *
 *   Kiosk problem? Call the number on the kiosk → GOLOCKER_KIOSK_HELP_URL
 *   Help Center                                  → Trashie FAQs (HELP_URL)
 *
 * The "Dropped it off but no Trashie Cash yet?" row left the design on 2026-10-20,
 * taking the drop-off status screens' only entry point with it.
 */
const GoLockerNeedHelp = ({ className }) => (
  <div className={`${styles.needHelp}${className ? ` ${className}` : ''}`}>
    <div className={styles.title}>Need Help?</div>
    <HelpLink href={GOLOCKER_KIOSK_HELP_URL}>Kiosk problem? Call the number on the kiosk</HelpLink>
    <HelpLink href={HELP_URL}>Help Center</HelpLink>
  </div>
);

export default GoLockerNeedHelp;
